export const SYSTEM_TIERS = [
    {id: '1', name: 'Tier 1 - Basic'},
    {id: '2', name: 'Tier 2 - Expanded'},
    {id: '3', name: 'Tier 3 - Complete'},
    {id: '4', name: 'Tier 4 - Enterprise'},
];

export const SECTIONS = [
    {
        id: 'admin',
        name: 'Admin - All',
        description: 'Provides unrestricted access to the CloudSent POS Administration portal.',
        type: 'full'
    },
    {
        id: 'client_all',
        name: 'Client - All',
        description: 'Provides unrestricted access to CloudSent POS devices.',
        type: 'full'
    },
    {
        id: 'reports',
        name: 'Reports - All',
        description: 'Provides unrestricted access to all Reports in the CloudSent POS Reports Admin.',
        type: 'full'
    },
    {
        id: 'loyalty_csr',
        name: 'Loyalty (Customer Service)',
        description: 'Aaccess to view and edit Loyalty Customers in the CloudSent POS Administration portal. Does not include access to edit Rank and Reward Points.',
        type: 'partial'
    },
    {
        id: 'loyalty_all',
        name: 'Loyalty (All)',
        description: 'Access to view and administer all Loyalty areas in the CloudSent POS Administration portal. Includes access to edit Rank and Reward Points.',
        type: 'partial'
    },
    {
        id: 'loyalty_vo',
        name: 'Loyalty View Only',
        description: 'Access to view all Loyalty areas in the CloudSent POS Administration portal. Includes access to view Rank and Reward Points.',
        type: 'partial'
    },
    {
        id: 'locations',
        name: 'Locations',
        description: 'Access to view and/or edit Locations, DBAs, Companies, Location Types, Districts and Price Levels.',
        type: 'partial'
    },
    {
        id: 'locations_vo',
        name: 'Locations View Only',
        description: 'Access to view Locations, DBAs, Companies, Location Types, Districts and Price Levels.',
        type: 'partial'
    },
    {
        id: 'products_all',
        name: 'Products (All)',
        description: 'Access to view and/or edit Product Types, Product Categories, Products and Product Units, Product Skus and Product Discounts including product unit and sku prices.',
        type: 'partial'
    },
    {
        id: 'products_np',
        name: 'Products (No Pricing)',
        description: 'Access to view and/or edit Product Types, Product Categories, Products and Product Units, Product Skus and Product Discounts however user will not be able to update prices for a product unit or sku.',
        type: 'partial'
    },
    {
        id: 'products_vo',
        name: 'Products View Only',
        description: 'Access to view Product Types, Product Categories, Products and Product Units, Product Skus and Product Discounts.',
        type: 'partial'
    },
    {
        id: 'inventory',
        name: 'Inventory',
        description: 'Access to view and/or edit Location Inventory, Repack / Retail Box Management, Repack / Retail Box Management, Transfer Audits, Location Audits and Missing Products.',
        type: 'partial'
    },
    {
        id: 'inventory_vo',
        name: 'Inventory View Only',
        description: 'Access to view Location Inventory, Repack / Retail Box Management, Repack / Retail Box Management, Transfer Audits, Location Audits and Missing Products.',
        type: 'partial'
    },
    {
        id: 'pos_kit',
        name: 'POS Kit',
        description: 'Access to view and/or edit POS Kits.',
        type: 'partial'
    },
    {
        id: 'pos_kit_vo',
        name: 'POS Kit View Only',
        description: 'Access to view POS Kits.',
        type: 'partial'
    },
    {
        id: 'pos_users',
        name: 'POS Users',
        description: 'Access to view and/or edit POS User Types, and POS Users.',
        type: 'partial'
    },
    {
        id: 'pos_users_vo',
        name: 'POS Users View Only',
        description: 'Access to view POS User Types, and POS Users.',
        type: 'partial'
    },
    {
        id: 'configuration',
        name: 'Configuration',
        description: 'Access to view and/or edit Admin Mode and Configurations.',
        type: 'partial'
    },
    {
        id: 'configuration_vo',
        name: 'Configuration View Only',
        description: 'Access to view Configurations.',
        type: 'partial'
    }
];



// WEBPACK FOOTER //
// ./src/Fuse/shared/systemLists.js